import { useEffect, useState } from 'react';

import ReactModal from 'react-modal';

import styles from './DrawDownModal.module.css';
import { Failed } from './Failed';
import { Loading } from './Loading';
import { Success } from './Success';
import { usePostFundSeller } from '../../../../api/lending/lapiHooks';
import { wait } from '../../../../utils/Wait';
import { useIsOverlay } from '../../../hooks/useIsOverlay';
import { useModal } from '../../../store/ModalProvider';
import { navigateToAccountPages } from '../../../utils/accountPages';

export const DRAW_DOWN_MODAL = 'DrawDownModal';

export const DISPLAY_TYPE_ENUM = {
  DEFAULT: 'DEFAULT',
  ECOMMERCE: 'ECOMMERCE',
  OVERLAY: 'OVERLAY',
} as const;
export type TDisplayType =
  (typeof DISPLAY_TYPE_ENUM)[keyof typeof DISPLAY_TYPE_ENUM];

export const DrawDownModal = () => {
  const { isOpen } = useModal(DRAW_DOWN_MODAL);
  const { postFundSeller, isLoading, isSuccess, isError } = usePostFundSeller();

  const [isRedirecting, setIsRedirecting] = useState(false);
  const isOverlay = useIsOverlay();

  const getDisplayType = () => {
    if (isOverlay) return DISPLAY_TYPE_ENUM.OVERLAY;
    if (isRedirecting) return DISPLAY_TYPE_ENUM.ECOMMERCE;

    return DISPLAY_TYPE_ENUM.DEFAULT;
  };

  const displayType = getDisplayType();

  const finishDrawDown = () => {
    navigateToAccountPages();
  };

  useEffect(() => {
    async function handlePostFundSeller() {
      if (!isOpen) return;

      try {
        const { redirect_url } = await postFundSeller();

        if (redirect_url && !isOverlay) {
          setIsRedirecting(true);

          await wait(700);
          window.location.href = redirect_url;
        }
      } catch (error) {
        // Ignore the error because we're checking it via isError
      }
    }

    void handlePostFundSeller();
  }, [isOpen, postFundSeller, isOverlay]);

  const getModalContent = () => {
    if (isSuccess) {
      return (
        <Success finishDrawDown={finishDrawDown} displayType={displayType} />
      );
    }
    if (isError) {
      return <Failed finishDrawDown={finishDrawDown} />;
    }
    if (isLoading) {
      return <Loading />;
    }
  };

  return (
    <ReactModal
      className={styles.ProcessingPaymentModal}
      overlayClassName={styles.tintedOverlay}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <div className={styles.content}>{getModalContent()}</div>
    </ReactModal>
  );
};
